class CustomSlider extends HTMLElement {
	constructor() {
		super();

		this.uniqueClass = `.splide--${this.dataset.id}`;
		this.init();
	}

	init() {
		new Splide(this.uniqueClass, {
			type: 'loop',
			perPage: 1,
			speed: 500,
			arrows: false,
		}).mount();
	}
}
customElements.define('custom-slider', CustomSlider);
